document.addEventListener('click', async e => {
  const btn = e.target.closest('.m-atc [data-add]');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  const wrap = btn.closest('.m-atc');
  const id = wrap.dataset.variant;
  wrap.classList.add('is-loading');

  try {
    // 1) Cart me add
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id, quantity: 1 }),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || 'Add failed');

    // 2) Header cart count
    const cart = await fetch('/cart.js').then(r => r.json());
    document.querySelectorAll('cart-icon').forEach(icon => {
      if (typeof icon.renderCartBubble === 'function') icon.renderCartBubble(cart.item_count);
    });

    // 3) Drawer ka content fresh laao
    const html = await fetch(window.location.href, { headers: { Accept: 'text/html' } }).then(r => r.text());
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const freshDrawer = doc.querySelector('cart-drawer-component');
    const drawerComp = document.querySelector('cart-drawer-component');
    if (freshDrawer && drawerComp) drawerComp.innerHTML = freshDrawer.innerHTML;

    // 4) Drawer open
    const themeDrawer = document.querySelector('theme-drawer:has(cart-drawer-component)') ||
      drawerComp?.closest('theme-drawer');
    console.log('[m-atc] themeDrawer:', themeDrawer);
    themeDrawer?.open();
  } catch (err) {
    console.error('[m-atc] error', err);
  } finally {
    wrap.classList.remove('is-loading');
  }
});
// Drawer ke andar Checkout dabate hi drawer band
document.addEventListener(
  'click',
  e => {
    const drawer = e.target.closest('theme-drawer');
    if (!drawer) return;

    const el = e.target.closest('button, a, input[type="submit"], [role="button"]');
    if (!el) return;

    const label = (el.textContent || el.value || el.getAttribute('aria-label') || '').toLowerCase();
    const attrs = ((el.name || '') + (el.id || '') + (el.className || '') + (el.getAttribute('href') || '')).toLowerCase();

    if (!label.includes('checkout') && !label.includes('check out') && !attrs.includes('checkout')) return;

    // Cashfree/theme ka apna handler chalne do, phir drawer band karo
    setTimeout(() => {
      if (typeof drawer.close === 'function') drawer.close();
      else drawer.querySelector('dialog')?.close();
    }, 100);
  },
  true
);